/*
 * Using the ?asset query parameter signals Webpack to export this CSS import
 * as a separate CSS file. We can include this separate. CSS file directly in
 * the Twig template so that the styles are available before the component mounts.
 *
 * IMPORTANT: These files NEED to be manually included somewhere in the Twig template
 * otherwise they won't work.
 */
import '@lokalise/token-dictionary/css/theme-lokalise-light.css?asset';
import '@lokalise/token-dictionary/css/theme-lokalise-dark.css?asset';
import '@lokalise/louis/style.css';
import '@lokalise/harmony/harmony.css';

import { StyleSheetManager, ThemeProvider as StyledThemeProvider } from '@lokalise/styled';
import type { FunctionComponent } from 'react';

import { themes } from '@app/theme';

import type { Props } from './types';

const ThemeProvider: FunctionComponent<Props> = ({ isDarkmode, children }: Props) => (
    <StyleSheetManager enableVendorPrefixes>
        <StyledThemeProvider theme={isDarkmode ? themes.darkTheme : themes.baseTheme}>
            {/* themeProvider to have option to select this element outside react scope */}
            <div data-type="themeProvider" data-theme={isDarkmode ? 'lokalise-dark' : 'lokalise-light'}>
                {children}
            </div>
        </StyledThemeProvider>
    </StyleSheetManager>
);

export default ThemeProvider;
